import { Pipe, PipeTransform } from '@angular/core';
import { PrintDocumentOverview } from '../models/print-documents/print-document-overview.interface';
import { DocumentCategory } from '../models/print-documents/print-document.interface';

@Pipe({
    name: 'documentCategory',
    standalone: false,
})
export class DocumentCategoryPipe implements PipeTransform {
    transform(val: PrintDocumentOverview): string {
        if (!val.category) {
            return val.categoryName === 'Dankeschreiben' ? 'Dankesschreiben' : 'Serienbrief';
        }

        switch (val.category) {
            case DocumentCategory.FORM_LETTER:
                return 'Serienbrief';
            case DocumentCategory.THANK_YOU_LETTER:
                return 'Dankesschreiben';
        }
    }
}
